module.exports = __webpack_public_path__ + "4f0b2bbd13d80bb56db798dffb9bf438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3.jpg
// module id = 226
// module chunks = 0